import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { FC } from "react";
import OauthButton from "./OauthButton";
import OauthHeader from "./OauthHeader";
import LinkFormSignIn from "./LinkFormSignIn";

export interface ISignUpFormState {
  email: string,
  firstName: string,
  password: string,
  passwordConfirm: string,
}

const SignUpForm: FC<{
  state: ISignUpFormState,
  stateErr: Partial<ISignUpFormState>,
  setState: (key: keyof ISignUpFormState, value: string) => unknown,
  onHandler: () => unknown,
}> = ({
  state,
  stateErr,
  setState,
  onHandler,
}) => (
  <>
    <OauthHeader>
      Sign up
    </OauthHeader>
    
    <Box sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label="Email Address"
        autoComplete="email"
        value={state.email}
        onChange={(e) => setState('email', e?.target?.value)}
        error={!!stateErr?.email}
        helperText={stateErr?.email ?? ''}
        autoFocus
      />
      <TextField
        margin="normal"
        fullWidth
        id="name"
        label="Name"
        autoComplete="name"
        value={state.firstName}
        onChange={(e) => setState('firstName', e?.target?.value)}
        error={!!stateErr?.firstName}
        helperText={stateErr?.firstName ?? ''}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="Password"
        type="password"
        id="password"
        value={state.password}
        onChange={(e) => setState('password', e?.target?.value)}
        error={!!stateErr?.password}
        helperText={stateErr?.password ?? ''}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="Repeat Password"
        type="password"
        id="passwordConfirm"
        value={state.passwordConfirm}
        onChange={(e) => setState('passwordConfirm', e?.target?.value)}
        error={!!stateErr?.passwordConfirm}
        helperText={stateErr?.passwordConfirm ?? ''}
      />
      <Grid container justifyContent='flex-end'>        
        Already have an account?&nbsp;<LinkFormSignIn />
      </Grid>
      <OauthButton onClick={onHandler}>
        Sign Up
      </OauthButton>
    </Box>
  </>
);

export default SignUpForm;
